const config = {
  development: {
    app_env: 'development',
    app_url: 'http://localhost:9005/',
    api_url: 'http://localhost:3000/',
    modfile_url: 'http://localhost:3002/',
    doconvert_url: 'http://localhost:3003/',
    provider_url: 'http://localhost:3004/',
    tinymce_key: 'al50f597z2kkhqjrnhnmqhu0wmu0os0l8kgbvhnpxk971ww3',
    default_image_url: {
      candidate: 'jtqqTaLbLknaVlV05OHd98tD7DvggODpzJEis8fFPMoXu5QAU8rde9P3bm0s1kQb_candidate.gif'
    },
    locales: [
      { label: 'English', value: 'en-US' },
      { label: 'Español', value: 'es-ES' },
      { label: 'Português Brasil', value: 'pt-BR' }
    ]
  },
  testing: {
    app_env: 'testing',
    app_url: 'https://app.testing.quickin.net/',
    api_url: 'https://api.testing.quickin.net/',
    modfile_url: 'https://modfile.testing.quickin.net/',
    doconvert_url: 'https://doconvert.testing.quickin.net/',
    provider_url: 'https://provider.testing.quickin.net/',
    tinymce_key: 'al50f597z2kkhqjrnhnmqhu0wmu0os0l8kgbvhnpxk971ww3',
    default_image_url: {
      candidate: 'jtqqTaLbLknaVlV05OHd98tD7DvggODpzJEis8fFPMoXu5QAU8rde9P3bm0s1kQb_candidate.gif'
    },
    locales: [
      { label: 'English', value: 'en-US' },
      { label: 'Español', value: 'es-ES' },
      { label: 'Português Brasil', value: 'pt-BR' }
    ]
  },
  staging: {
    app_env: 'staging',
    app_url: 'https://app.staging.quickin.net/',
    api_url: 'https://api.staging.quickin.net/',
    modfile_url: 'https://modfile.staging.quickin.net/',
    doconvert_url: 'https://doconvert.staging.quickin.net/',
    provider_url: 'https://provider.staging.quickin.net/',
    tinymce_key: 'al50f597z2kkhqjrnhnmqhu0wmu0os0l8kgbvhnpxk971ww3',
    default_image_url: {
      candidate: 'jtqqTaLbLknaVlV05OHd98tD7DvggODpzJEis8fFPMoXu5QAU8rde9P3bm0s1kQb_candidate.gif'
    },
    locales: [
      { label: 'English', value: 'en-US' },
      { label: 'Español', value: 'es-ES' },
      { label: 'Português Brasil', value: 'pt-BR' }
    ]
  },
  production: {
    app_env: 'production',
    app_url: 'https://app.quickin.io/',
    api_url: 'https://api.quickin.io/',
    modfile_url: 'https://modfile.quickin.io/',
    doconvert_url: 'https://doconvert.quickin.io/',
    provider_url: 'https://provider.quickin.io/',
    tinymce_key: 'al50f597z2kkhqjrnhnmqhu0wmu0os0l8kgbvhnpxk971ww3',
    default_image_url: {
      candidate: 'jtqqTaLbLknaVlV05OHd98tD7DvggODpzJEis8fFPMoXu5QAU8rde9P3bm0s1kQb_candidate.gif'
    },
    locales: [
      { label: 'English', value: 'en-US' },
      { label: 'Español', value: 'es-ES' },
      { label: 'Português Brasil', value: 'pt-BR' }
    ]
  }
}

console.log('Env: ' + process.env.NODE_ENV)
module.exports = config[process.env.NODE_ENV || 'development']



// WEBPACK FOOTER //
// ./src/config.js